module.exports = __webpack_public_path__ + "img/Unplugged car.afc50104.svg";